import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ListSectionList } from './ListSectionList';
import { Centralized } from '../layout';
import { Section } from '../Section';

const StyledJapanShippingStatistics = styled(Section)`
  max-width: 70rem;
  margin: 0 auto;
`;

const ListSection = ({
  data,
  component,
}) => (
  <StyledJapanShippingStatistics>
    <Centralized>
      <ListSectionList
        data={data}
        component={component}
      />
    </Centralized>
  </StyledJapanShippingStatistics>
);

ListSection.propTypes = {
  // eslint-disable-next-line
  data: PropTypes.array.isRequired,
  component: PropTypes.func.isRequired,
};

export { ListSection };